import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { actions } from '../../constants/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewPropertyHistoryButton = ({
  invoicePropertyHistoryLink,
  onClickButton
}) => {
  return /*#__PURE__*/_jsx(Link, {
    onClick: () => {
      onClickButton(actions.VIEW_PROPERTY_HISTORY);
    },
    "data-test-id": "view-property-history-btn",
    external: true,
    href: invoicePropertyHistoryLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.buttons.viewPropertyHistory"
    })
  }, "view-property-history-btn");
};
export default ViewPropertyHistoryButton;